import { Progress } from '@any-ui-react/core';
import { useMemo } from 'react';
import { NumberUtils } from '@/common/utils';

interface CellValueProgressProps {
  totalRequestCount: number | null | undefined;
  completedRequestCount: number;
}

export const CellValueProgress = ({ totalRequestCount, completedRequestCount }: CellValueProgressProps) => {
  // Accepted | InProgress — show the live progress bar.
  const value = useMemo(
    () => (totalRequestCount ? (completedRequestCount * 100) / totalRequestCount : 0),
    [totalRequestCount, completedRequestCount],
  );

  return (
    <div className="flex items-center gap-2 w-full">
      <div className="tabular-nums text-2xs">
        {totalRequestCount
          ? NumberUtils.formatDecimalToPercent(completedRequestCount / totalRequestCount, { omitSuffix: false })
          : '0%'}
      </div>
      <Progress
        value={value}
        animated={completedRequestCount > 0}
        color={value >= 75 ? 'blue' : value >= 50 ? 'lime' : value >= 25 ? 'orange' : 'red'}
        className="flex-1"
      />
    </div>
  );
};
